// Tooltip for an exercise that started without some participants (undeliverable invite email).
const INVITE_FAILURE_REASONS = {
  INVITE_EMAIL_SUPPRESSED: "the email provider has marked the address inactive (bounced, reported as spam, or suppressed)",
  INVITE_EMAIL_INVALID: "the address isn't valid",
}
export const inviteFailuresTooltip = (failures = []) => {
  const lines = failures.map((f) => `${f.email} — ${INVITE_FAILURE_REASONS[f.code] || "the invite email couldn't be delivered"}`)
  const head = failures.length === 1 ? "1 participant wasn't invited" : `${failures.length} participants weren't invited`
  return `${head}: ${lines.join("; ")}. Everyone else was invited.`
}
